import { Middlewares } from "@/app/shared/services/app-router/middlewares";
import { RouterHooks } from "@/app/shared/services/app-router/hooks";
import Guard from "vue-router-multiguard";
import registrationRoutes from "./registration/registration-routes";

const mobilePanelRoutes = [
    {
        path: "offers",
        name: "PanelOffers",
        component: () => import("./offers/views/offers"),
        beforeEnter: Guard([
            Middlewares.authRequired,
            Middlewares.clientAccess,
            RouterHooks.enablePaymentsNotifications,
        ]),
    },
    {
        path: "profile",
        name: "PanelProfile",
        component: () => import("./profile/views/profile"),
        beforeEnter: Guard([
            Middlewares.authRequired,
            Middlewares.clientAccess,
            RouterHooks.enablePaymentsNotifications,
        ]),
    },
    {
        path: "my_applications",
        name: "PanelMyApplications",
        component: () => import("./applications/views/applications"),
        beforeEnter: Guard([
            Middlewares.authRequired,
            Middlewares.clientAccess,
            RouterHooks.enablePaymentsNotifications,
        ]),
    },
];

const mobileRoutes = [
    ...registrationRoutes,
    {
        path: "/login",
        name: "Login",
        component: () => import("./login"),
    },
    {
        path: "/auto-register",
        name: "AutoRegister",
        beforeEnter: Guard([Middlewares.autoReg]),
    },
    {
        path: "/panel",
        name: "Panel",
        component: () => import("./panel"),
        beforeEnter: Guard([Middlewares.authByApiKey, Middlewares.authRequired]),
        children: mobilePanelRoutes,
    },
];

export default mobileRoutes;
